"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _connect = require("../../actions/connect");

var _disconnect = require("../../actions/disconnect");

var _reconnect = require("../../actions/reconnect");

function _default(fn) {
  return (0, _effects.call)(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee() {
    var _ref, _ref$meta, userID, username, directLine, task;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _effects.take)([_connect.CONNECT_FULFILLING, _reconnect.RECONNECT_FULFILLING]);

          case 2:
            _ref = _context.sent;
            _ref$meta = _ref.meta;
            userID = _ref$meta.userID;
            username = _ref$meta.username;
            directLine = _ref.payload.directLine;
            _context.next = 9;
            return (0, _effects.fork)(fn, {
              directLine: directLine,
              userID: userID,
              username: username
            });

          case 9:
            task = _context.sent;
            _context.next = 12;
            return (0, _effects.take)([_disconnect.DISCONNECT_PENDING, _reconnect.RECONNECT_PENDING]);

          case 12:
            _context.next = 14;
            return (0, _effects.cancel)(task);

          case 14:
            _context.next = 0;
            break;

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}